import {Component, Input} from '@angular/core';
import {FormControl, NgControl} from '@angular/forms';
import {ACTIONS_TYPES, EVENT_KATEGORIE, PiwikService} from '@wba/commons/modules/piwik';

@Component({
    selector: 'wba-error-message',
    templateUrl: './error-message.component.html',
    standalone: false
})
export class ErrorMessageComponent {

  @Input() errorMessage = 'Fehler';
  @Input() _id = '';
  @Input() control: FormControl | NgControl;
  @Input() isVisible: boolean;
  isEventSent = false;
  constructor(private readonly piwikService: PiwikService) {

  }

  getErrorMessageId() {
    if (this.control.errors) {
      return this._id + '_Error_Message_';
    }
    return '';
  }

  hasError() {
    const hasError = this.control.touched && this.control.errors?.typ === 'error';
    if (hasError && !this.isEventSent) {
      this.isEventSent = true;
      this.piwikService.trackEventAction(EVENT_KATEGORIE.FEHLER, ACTIONS_TYPES.FORM, this.getErrorMessageId());
    }
    return hasError;
  }

  hasWarning() {
    return this.control.touched && this.control.errors?.typ === 'warning';
  }
 }
